module.exports = __webpack_public_path__ + "img/icon_police_03.ac967a19.png";